import { CHIP } from './chartChrome'
import { GROWTH_UP, GROWTH_DOWN } from './chartStyle'
import { formatGrowthPercent } from '~/util/numbers'

export interface GrowthDisplay {
  text: string
  /** Status hex for the signed directions; null = neutral — the consumer picks its own
   *  muted treatment (GrowthChip: the `text.secondary` theme token; SVG: GROWTH_NEUTRAL). */
  color: string | null
}

/** Wave-5 §3 (D4): THE sign→glyph/color/text mapping — single source for GrowthChip and
 *  SummaryBarStrip's in-chart labels. Arrow carries the sign (callers get |growth| text),
 *  zero/baseline are neutral. Non-finite returns null: render NOTHING rather than a
 *  fabricated number (fable wave-4 Minor — unreachable through today's producers). */
export function growthDisplay(growth: number, baseline = false): GrowthDisplay | null {
  if (baseline) return { text: CHIP.growthZero, color: null }
  if (!Number.isFinite(growth)) return null
  if (growth === 0) return { text: CHIP.growthZero, color: null }
  return growth > 0
    ? { text: CHIP.growthUp(formatGrowthPercent(growth)), color: GROWTH_UP }
    : { text: CHIP.growthDown(formatGrowthPercent(Math.abs(growth))), color: GROWTH_DOWN }
}
